import { gql } from '@apollo/client';

export const lithologyQueryResult = `
  id,
  order,
  code,
  label
`;

export const GET_LITHOLOGY = gql`
  query getLithologies($code: String, $skip: Int, $take: Int) {
    lithologies(code: $code, skip: $skip, take: $take) {
      items {
        ${lithologyQueryResult}
      },
      totalCount
    }
  }
`;
